<template>
  <div>
    <div class="Header">
      <Header :ismenu="true"></Header>
    </div>
    <div class="header_box"></div>
    <router-view/>

    <Footer></Footer>
    <div v-if="$store.state.load" class="shadeLoad fx2">
      <div class="circle-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/header/index.vue'
import Footer from "@/components/footer/index.vue";

export default {
  
  components: {
    Header,
    Footer
  },
  data(){
    return {
      show: false,
    }
  },
  computed:{
    clientWidth(){
      return this.$store.state.clientWidth + ''
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss'
</style>